import { type AdServerAdBannerDimensions } from '../../../ad-server'
import { type StoryblokAdBannerType } from '../../storyblok'

export const storyblokAdBannerParseDimensions = (
  dimensions:
    | StoryblokAdBannerType['dimensions']
    | StoryblokAdBannerType['dimensionsMobile'],
): AdServerAdBannerDimensions | undefined => {
  if (!dimensions) {
    return undefined
  }

  // eslint-disable-next-line unicorn/try-complexity -- don't reference, refactor if touched
  try {
    const parsed = JSON.parse(dimensions) as AdServerAdBannerDimensions

    if (!parsed.height || !parsed.width) {
      return undefined
    }

    return parsed
  } catch {
    return undefined
  }
}
